import { lazy } from "react";
import { Navigate, Outlet } from "react-router-dom";
// auth
import { GuestGuard } from "src/auth/guard";
// routes
import { paths } from "src/routes/paths";

// ----------------------------------------------------------------------


// eslint-disable-next-line consistent-return
async function safeImport(loader, retries = 1) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i <= retries; i++) {
        try {
            // eslint-disable-next-line no-await-in-loop
            return await loader();
        } catch (e) {
            const isChunkErr = /ChunkLoadError|Loading chunk \d+ failed|importing a module script failed/i.test(String(e?.message || e));
            if (!isChunkErr || i === retries) throw e;
            // 等待片刻再重试
            // eslint-disable-next-line no-await-in-loop
            await new Promise(r => setTimeout(r, 500));
        }
    }
}


// JWT
const JwtLoginPage = lazy(() => safeImport(() => import("src/pages/auth/login")));
const JwtNewPasswordPage = lazy(() => safeImport(() => import("src/pages/auth/new-password")));

// ----------------------------------------------------------------------

export const authRoutes = [
    {
        path: "/",
        element: (
            <GuestGuard>
                <Outlet />
            </GuestGuard>
        ),
        children: [
            { path: "", element: <Navigate to={paths.auth.login} replace /> },
            { path: "login", element: <JwtLoginPage />, index: true },
            { path: "new-password", element: <JwtNewPasswordPage /> }
        ]
    }
];
